"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createActivity = createActivity;
exports.deleteActivity = deleteActivity;
exports.getActivityDetail = getActivityDetail;
exports.getActivityPage = getActivityPage;
exports.updateActivity = updateActivity;
exports.updateActivityStatus = updateActivityStatus;
exports.uploadActivityImage = uploadActivityImage;
exports.uploadActivityImageSeparate = uploadActivityImageSeparate;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 获取活动列表
function getActivityPage(query) {
  return (0, _requestPIM.default)({
    url: '/xyActivityZone/page',
    method: 'get',
    params: query
  });
}

// 添加新活动
function createActivity(data) {
  return (0, _requestPIM.default)({
    url: '/xyActivityZone/insert',
    method: 'post',
    data: data
  });
}

// 编辑活动
function updateActivity(data) {
  return (0, _requestPIM.default)({
    url: '/xyActivityZone/basicUpdate',
    method: 'put',
    data: data
  });
}

// 编辑状态
function updateActivityStatus(data) {
  return (0, _requestPIM.default)({
    url: '/xyActivityZone/updateStatus',
    method: 'put',
    data: data
  });
}

// 删除活动信息
function deleteActivity(id) {
  return (0, _requestPIM.default)({
    url: '/xyActivityZone?id=' + id,
    method: 'delete'
  });
}

// 通过id获取活动信息
function getActivityDetail(id) {
  return (0, _requestPIM.default)({
    url: '/xyActivityZone/' + id,
    method: 'get'
  });
}

// 上传图片-返回路径
function uploadActivityImage(params) {
  return (0, _requestPIM.default)({
    url: '/xyActivityZone/uploadActivityPhoto',
    method: 'post',
    data: params
  });
}

// 上传图片-修改变量
function uploadActivityImageSeparate(params) {
  return (0, _requestPIM.default)({
    url: '/xyActivityZone/uploadActivityImageSeparate',
    method: 'post',
    data: params
  });
}